import {Field} from 'formik';

import {
    FormikSelect,
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Stack} from '@mantine/core';
import {PlaybookStatus} from '../types';


export const FormComponent = () => {

    return (
        <Stack gap={'xl'}>
            <PlatformFieldset legend={'Playbook Details'}>
                <Field
                    name='name'
                    label='Name'
                    description='Machine-readable identifier (e.g. "create-react-spa-application")'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='displayName'
                    label='Display Name'
                    description='Human-friendly name shown in the UI'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='description'
                    label='Description'
                    description='What this playbook does'
                    component={FormikTextarea}
                    my={'xl'}
                />

                <Field
                    name='category'
                    label='Category'
                    description='Grouping for related playbooks (e.g. "application-provisioning")'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='status'
                    label='Status'
                    description='Lifecycle status of this playbook'
                    component={FormikSelect}
                    data={Object.values(PlaybookStatus).map(value => ({
                        label: value,
                        value,
                    }))}
                    withAsterisk
                    my={'xl'}
                />
            </PlatformFieldset>

            <PlatformFieldset legend={'Execution Binding'}>
                <Field
                    name='stateMachineArn'
                    label='State Machine ARN'
                    description='ARN of the Step Functions state machine that executes this playbook'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='inputSchema'
                    label='Input Schema'
                    description='JSON Schema describing the expected executePlaybook input (optional)'
                    component={FormikTextarea}
                    autosize
                    minRows={4}
                    my={'xl'}
                />
            </PlatformFieldset>
        </Stack>
    );
};
